import { render, staticRenderFns } from "./ExternalIDInput.vue?vue&type=template&id=6ed268e4&scoped=true"
import script from "./ExternalIDInput.vue?vue&type=script&lang=js"
export * from "./ExternalIDInput.vue?vue&type=script&lang=js"
import style0 from "./ExternalIDInput.vue?vue&type=style&index=0&id=6ed268e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed268e4",
  null
  
)

export default component.exports